import { Direction } from '../../contexts/session/Locale.js';

var defaultProps = {
  backgroundColor: 'base.surface',
  autoFocus: true
};
var mapOverlayTransform = function mapOverlayTransform(direction) {
  if (direction === Direction.RTL) {
    return 'translate3d(-100%, 0, 0)';
  }
  return 'translate3d(100%, 0, 0)';
};

export { defaultProps, mapOverlayTransform };
//# sourceMappingURL=FullScreenSheet.mappers.js.map
